// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homePageContent{
    padding-top: 20px;
    background: white;
    height: 100%;
}

.center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width:100%
}

.navHead {
    color: teal;
    font-size: 20px;
    font-weight: bold;
}

.info {
    font-size: 13px;
}

.userIcon {
    background: url('CMI-WebIcon-Sprite-New.png') no-repeat -96px -2088px;
    width: 30px;
    height: 30px;
    display: inline-block;
  }

sup {
    font-size: 50%;
    top: -1em;
}

.cursorPointer {
    cursor: pointer;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImV4dGVybmFsLXVzZXItbG9naW4uY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGlCQUFpQjtJQUNqQixpQkFBaUI7SUFDakIsWUFBWTtBQUNoQjs7QUFFQTtJQUNJLGNBQWM7SUFDZCxpQkFBaUI7SUFDakIsa0JBQWtCO0lBQ2xCO0FBQ0o7O0FBRUE7SUFDSSxXQUFXO0lBQ1gsZUFBZTtJQUNmLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJLGVBQWU7QUFDbkI7O0FBRUE7SUFDSSxxRUFBNEY7SUFDNUYsV0FBVztJQUNYLFlBQVk7SUFDWixxQkFBcUI7RUFDdkI7O0FBRUY7SUFDSSxjQUFjO0lBQ2QsU0FBUztBQUNiOztBQUVBO0lBQ0ksZUFBZTtBQUNuQiIsImZpbGUiOiJleHRlcm5hbC11c2VyLWxvZ2luLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuaG9tZVBhZ2VDb250ZW50e1xyXG4gICAgcGFkZGluZy10b3A6IDIwcHg7XHJcbiAgICBiYWNrZ3JvdW5kOiB3aGl0ZTtcclxuICAgIGhlaWdodDogMTAwJTtcclxufVxyXG5cclxuLmNlbnRlciB7XHJcbiAgICBkaXNwbGF5OiBibG9jaztcclxuICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xyXG4gICAgbWFyZ2luLXJpZ2h0OiBhdXRvO1xyXG4gICAgd2lkdGg6MTAwJVxyXG59XHJcblxyXG4ubmF2SGVhZCB7XHJcbiAgICBjb2xvcjogdGVhbDtcclxuICAgIGZvbnQtc2l6ZTogMjBweDtcclxuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xyXG59XHJcblxyXG4uaW5mbyB7XHJcbiAgICBmb250LXNpemU6IDEzcHg7XHJcbn1cclxuXHJcbi51c2VySWNvbiB7XHJcbiAgICBiYWNrZ3JvdW5kOiB1cmwoJy4uLy4uLy4uLy4uL2Fzc2V0cy9pbWcvQ01JLVdlYkljb24tU3ByaXRlLU5ldy5wbmcnKSBuby1yZXBlYXQgLTk2cHggLTIwODhweDtcclxuICAgIHdpZHRoOiAzMHB4O1xyXG4gICAgaGVpZ2h0OiAzMHB4O1xyXG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xyXG4gIH1cclxuXHJcbnN1cCB7XHJcbiAgICBmb250LXNpemU6IDUwJTtcclxuICAgIHRvcDogLTFlbTtcclxufVxyXG5cclxuLmN1cnNvclBvaW50ZXIge1xyXG4gICAgY3Vyc29yOiBwb2ludGVyO1xyXG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/external-user-login/external-user-login.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qEAA4F;IAC5F,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;AAEF;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;AACA,w9CAAw9C","sourcesContent":[".homePageContent{\r\n    padding-top: 20px;\r\n    background: white;\r\n    height: 100%;\r\n}\r\n\r\n.center {\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    width:100%\r\n}\r\n\r\n.navHead {\r\n    color: teal;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n.info {\r\n    font-size: 13px;\r\n}\r\n\r\n.userIcon {\r\n    background: url('../../../../assets/img/CMI-WebIcon-Sprite-New.png') no-repeat -96px -2088px;\r\n    width: 30px;\r\n    height: 30px;\r\n    display: inline-block;\r\n  }\r\n\r\nsup {\r\n    font-size: 50%;\r\n    top: -1em;\r\n}\r\n\r\n.cursorPointer {\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
